import classnames from 'classnames';
import type { SwitchElementProps } from './Switch.types';

import classNames from 'classnames';
import type { CSSProperties } from 'react';
import { Switch, SwitchThumb } from '../ui/Switch';
import * as styles from './Switch.css';

export function SwitchElement(props: SwitchElementProps) {
  const { element, children, className, attributes, isLive, onCheckedChange, checked, name, value } = props;
  const {
    id,
    mobile_hide,
    desktop_hide,
    customAttributes,
    backgroundColor,
    thumbColor,
    padding,
    borderRadius,
    mobileWidth,
    mobileMaxWidth,
    width,
    maxWidth,
    backgroundColorSelect,
    gap,
    labelPlacement,
  } = element.attrs || {};

  return (
    <div
      {...customAttributes}
      className={classnames(
        className,
        {
          'mobile:hidden': mobile_hide,
          'desktop:hidden': desktop_hide,
        },
        styles.switchElement,
        customAttributes?.className,
      )}
      style={
        {
          '--padding': padding ?? '12px 0px',
          '--background-color': checked ? backgroundColorSelect : backgroundColor,
          '--width': width,
          '--max-width': maxWidth,
          '--mobile-width': mobileWidth,
          '--mobile-max-width': mobileMaxWidth,
          '--border-radius': borderRadius,
          '--thumb-color': thumbColor,
          '--gap': gap || '5px',
        } as CSSProperties
      }
      {...attributes}
    >
      {labelPlacement === 'start' && children}
      <Switch
        onCheckedChange={onCheckedChange}
        checked={checked}
        className={classNames(styles.switchRoot, !isLive && 'pointer-events-none')}
        id={id}
        name={name}
        value={value}
      >
        <SwitchThumb className={classNames(styles.switchThumb)} />
      </Switch>
      {labelPlacement === 'end' && children}
    </div>
  );
}
